import { render, staticRenderFns } from "./Routines.vue?vue&type=template&id=3ae20463&scoped=true&"
import script from "./Routines.vue?vue&type=script&lang=js&"
export * from "./Routines.vue?vue&type=script&lang=js&"
import style0 from "./Routines.vue?vue&type=style&index=0&id=3ae20463&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae20463",
  null
  
)

export default component.exports